// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite/dist/flowbite.turbo.js";
import "chartkick/chart.js"
document.addEventListener("turbo:frame-load", (event) => {
    if (event.target.id === "main_frame") {
        window.scrollTo({ top: 0, behavior: "smooth" })
    }
})